import remoteLoader from './remoteLoader';

export type { RemoteLoaderOptions } from './remoteLoader';
export * from './resolvers';
export * from './types';

export default remoteLoader;
